import { View, Text, Linking } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { RotateCcw, TriangleAlert } from "lucide-react-native";
import { PrimaryButton, TextActionButton } from "@louise/moon-ui";
import { useTranslations } from "@src/packages/i18n";
import { EMBER } from "../onboarding/theme";

type Props = {
  title?: string;
  message?: string;
  onReload?: () => void;
};

export function ErrorScreen({ title, message, onReload }: Props) {
  const t = useTranslations();
  return (
    <View
      style={{
        flex: 1,
        backgroundColor: EMBER.colors.surface,
      }}
    >
      <SafeAreaView
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          paddingHorizontal: 32,
        }}
      >
        <TriangleAlert size={40} color={EMBER.colors.coral} strokeWidth={1.5} />

        <Text
          className="font-dm-sans"
          style={{
            fontSize: 22,
            fontWeight: "700",
            color: EMBER.colors.text,
            textAlign: "center",
            marginTop: 20,
            marginBottom: 8,
          }}
        >
          {title ?? t("app_error.something_went_wrong")}
        </Text>

        <Text
          className="font-dm-sans"
          style={{
            fontSize: 14,
            color: EMBER.colors.textMid,
            textAlign: "center",
            lineHeight: 20,
            maxWidth: 300,
            marginBottom: 32,
          }}
        >
          {message ?? t("app_error.unexpected_issue_try_again")}
        </Text>

        {onReload ? (
          <PrimaryButton
            label={t("app_error.reload_the_app")}
            action="app_error.reload"
            icon={<RotateCcw size={16} color="#FFFFFF" strokeWidth={2} />}
            onPress={onReload}
            style={{ marginBottom: 12, width: "100%", maxWidth: 320 }}
          />
        ) : null}

        <TextActionButton
          label={t("app_error.contact_support")}
          action="app_error.contact_support"
          tone="tertiary"
          size="sm"
          onPress={() => void Linking.openURL("mailto:support@louise.life")}
        />
      </SafeAreaView>
    </View>
  );
}
